<template>
  <div class="structured-inner-wrapper bordered mb-8" :class="{ disabled: !isActive }">
    <div class="mb-5">
      <Checkbox
        name="monitoring.notify.byEmail"
        label="monitoring.notify.byEmail"
        label-class="mt-0 mb-2"
        :value="settings.byEmail"
        @input="update('byEmail', $event)"
      />
      <EditableItem
        type="email"
        email
        name="settings.email"
        :isMonitoring="true"
        :isEditable="settings.byEmail"
        :value="settings.email"
        @save="update('email', $event)"
      />
    </div>
    <Checkbox
      name="monitoring.notify.bySms"
      label="monitoring.notify.bySms"
      label-class="mt-0 mb-2"
      :value="settings.bySms"
      @input="update('bySms', $event)"
    />
    <EditableItem
      name="settings.phone"
      phone
      type="tel"
      :isEditable="settings.bySms"
      :isMonitoring="true"
      :value="settings.phone"
      @save="update('phone', $event)"
    />
  </div>
</template>

<script>
import Checkbox from './Checkbox';
import EditableItem from './EditableItem';

export default {
  props: {
    userSettings: Object,
  },
  components: {
    Checkbox,
    EditableItem,
  },
  data() {
    return {
      debounceId: -1,
      settings: {},
    };
  },
  watch: {
    userSettings: {
      immediate: true,
      handler: 'updateSettings',
    },
  },
  computed: {
    isActive() {
      return this.userSettings && this.userSettings.isActive;
    },
  },
  methods: {
    updateSettings(settings) {
      const defaultSettings = this.buildSettings();

      if (settings.isActive) {
        this.settings = Object.keys(defaultSettings).reduce((object, name) => {
          object[name] = settings[name] || defaultSettings[name];
          return object;
        }, {});
      } else {
        this.settings = defaultSettings;
      }
    },
    buildSettings() {
      return {
        bySms: false,
        byEmail: false,
        phone: '',
        email: '',
      };
    },
    update(name, value) {
      this.settings[name] = value;

      if (name === 'bySms' && !this.settings.phone || name === 'byEmail' && !this.settings.email) {
        return;
      }

      if (!value) {
        switch (name) {
          case 'email':
            this.settings.byEmail = false;
            break;
          case 'phone':
            this.settings.bySms = false;
            break;
          case 'byEmail':
            this.settings.email = '';
            break;
          case 'bySms':
            this.settings.phone = '';
            break;
          default:
            break;
        }
      }

      this.emitUpdate();
    },
    emitUpdate() {
      clearTimeout(this.debounceId);
      this.debounceId = setTimeout(() => this.$emit('update', this.settings), 500);
    },
  },
};
</script>
